import { render, staticRenderFns } from "./FormHandling.vue?vue&type=template&id=3b0b862e&"
import script from "./FormHandling.vue?vue&type=script&lang=js&"
export * from "./FormHandling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b0b862e')) {
      api.createRecord('3b0b862e', component.options)
    } else {
      api.reload('3b0b862e', component.options)
    }
    module.hot.accept("./FormHandling.vue?vue&type=template&id=3b0b862e&", function () {
      api.rerender('3b0b862e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/incident/handling/FormHandling.vue"
export default component.exports